// extracted by mini-css-extract-plugin
module.exports = {"itemBody":"AboutPolicy_itemBody__v9sis","title":"AboutPolicy_title__3IKha","moreButton":"AboutPolicy_moreButton__lVcn4","newsWrapper":"AboutPolicy_newsWrapper__1tDU9"};